import { Redirect, Route } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { routes } from "../../routes";
import { isAuthenticated } from '../../utils';

const PrivateRouter = () => {

    return (
        routes.map(({ path, Component, title }, key) => (
            <Route exact path={path} render={(props) =>
                isAuthenticated() ?
                    <>
                        {title &&
                            <Helmet>
                                <title>{title}</title>
                            </Helmet>
                        }
                        <Component {...props} />
                    </>
                    : <Redirect to={{ pathname: '/signin', user: isAuthenticated, state: { from: props.location } }} />
            } key={key} />
        ))
    )
};

export default PrivateRouter
